<template>
	<v-container>
		<v-row>
			<v-col
					cols="12"
					sm="10"
					md="8"
					lg="6"
			>
				<v-card outlined>
					<v-card-title>
						Теги
					</v-card-title>
					<v-data-table
							:headers="headers"
							:items="tags.data"
							:loading="loading"
							:server-items-length="tags.meta.total"
							loading-text="Загрузка..."
							disable-sort
							disable-filtering
							@pagination="handlePagination"
					>
						<template #item.color="{ item }">
							<edit-color-menu
									:tag-id="item.id"
									:colors="tags.meta.colors"
									@changed="replaceTag"
							>
								<template #activator="{ on }">
									<v-chip
											:color="item.color"
											small
											v-on="on"
											v-html="colorChipText"
									/>
								</template>
							</edit-color-menu>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

	import EditColorMenu from '@/components/tags/EditColorMenu';
	const HEADERS = [
		{
			text: 'ID',
			value: 'id',
		},
		{
			text: 'Название',
			value: 'display_name',
		},
		{
			text: 'Цвет',
			value: 'color',
		},
	];

	export default {
		name: 'index',
		components: { EditColorMenu },
		data: () => ({
			loading: false,
			tags: {
				data: [],
				meta: {
					total: 0,
					current_page: 1,
					per_page: 10,
					colors: [],
				},
			},
		}),
		computed: {
			colorChipText() {
				const symbol = '&nbsp;';
				const amount = 15;

				return (new Array(amount)).join(symbol);
			},
			headers() {
				return HEADERS;
			},
		},
		mounted() {
			this.getTags();
		},
		methods: {
			getTags(options = {}) {
				if (this.loading) {
					return;
				}
				this.loading = true;

				const currentOptions = {
					page: this.tags.meta.current_page,
					limit: this.tags.meta.per_page,
				};

				this.$http.get('/api/v1/tags', {
					params: {
						...currentOptions,
						...options,
					},
				})
					.then(response => {
						this.tags = response.data;
					})
					.finally(() => (this.loading = false));
			},
			replaceTag(newTag) {
				this.tags.data = this.tags.data.map(tag => tag.id === newTag.id ? newTag : tag);
			},
			handlePagination(pagination) {
				if (pagination.page === this.tags.meta.current_page && pagination.itemsPerPage === this.tags.meta.per_page) {
					return;
				}

				this.getTags({
					page: pagination.page,
					limit: pagination.itemsPerPage,
				});
			},
		},
	};
</script>

<style scoped>

</style>
